import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { WrittenDirectivesProvider } from './context';
import WrittenDirectivesList from './List';
import WrittenDirectiveDetail from './Detail';

const WrittenDirectives = () => {
  const { id: accreditationId, versionId, standardId, jurisdictionId } = useParams();
  return (
    <WrittenDirectivesProvider
      accreditingBodyId={accreditationId!}
      versionId={versionId!}
      standardId={standardId!}
      jurisdictionId={jurisdictionId!}
    >
      <Routes>
        <Route
          path=':directiveId'
          element={<WrittenDirectiveDetail />}
        />
        <Route
          path=''
          element={<WrittenDirectivesList />}
        />
      </Routes>
    </WrittenDirectivesProvider>
  );
};

export default WrittenDirectives;
